const components = {
  Overview: () => import('@/apps/components/Overview'),
  ApplicationList: () => import('@/apps/components/ApplicationList'),
  BuildList: () => import('@/apps/components/BuildList'),
  ApplicationDetail: () => import('@/apps/components/ApplicationDetail'),
  TagDetail: () => import('@/apps/components/TagDetail'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId')
}

const routes = [
  {
    path: '/',
    name: 'Apps',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'Apps - Overview',
    display_name: 'searchbar.items.apps.overview.display_name',
    description: 'searchbar.items.apps.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: ['apps_applications']
    }
  },
  {
    path: '/:dataplantId/applications',
    name: 'Apps - Applications',
    display_name: 'searchbar.items.apps.applications.display_name',
    description: 'searchbar.items.apps.applications.description',
    searchable: true,
    component: components.ApplicationList,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Applications - ${parent(route, false)}`,
      // `acl` too: this page gates its create action, and an unloaded right counts as granted.
      ready: ['apps_applications', 'acl']
    }
  },
  {
    path: '/:dataplantId/builds',
    name: 'Apps - Builds',
    display_name: 'searchbar.items.apps.builds.display_name',
    description: 'searchbar.items.apps.builds.description',
    searchable: true,
    component: components.BuildList,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Builds - ${parent(route, false)}`,
      ready: ['apps_applications']
    }
  },
  {
    path: '/:dataplantId/:appName',
    name: 'Apps - Application Detail',
    component: components.ApplicationDetail,
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `${route.params.appName} - ${parent(route, false)}`,
      // `acl` too: this page gates version create and copy.
      ready: ['apps_applications', 'acl']
    }
  },
  {
    path: '/:dataplantId/:appName/:tagName',
    name: 'Apps - Tag Detail',
    component: components.TagDetail,
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `${route.params.tagName} - ${route.params.appName} - ${parent(route, false)}`,
      ready: ['apps_applications']
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'Apps' }
  }
]

export const basePath = 'apps/'
export default routes
